import { Plugin, App } from "vue";

/**
 * Ensure that the global properties are available throughout the Vue App
 */
export const VueGlobalProperties: Plugin = {
    install(app: App) {
        app.config.globalProperties.$environment = ENVIRONMENT;
        app.config.globalProperties.$platform    = PLATFORM;
        app.config.globalProperties.sizeDesktop  = SIZE_DESKTOP;
        app.config.globalProperties.sizeTablet   = SIZE_TABLET;
        app.config.globalProperties.sizeMobile   = SIZE_MOBILE;
        app.config.globalProperties.$app         = {
            commitHash  : COMMIT_HASH,
            buildHash   : BUILD_HASH,
            version     : VERSION,
            // Apply Package.json "app" object
            ...PACKAGE_APP
        };
    }
};

export default VueGlobalProperties;